import React, { useEffect, useRef, useState } from "react";
import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { itemStatusData } from "../../../../data";

const { TextArea } = Input;

const AddStoreRequestModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saving } = useSelector((state) => state.save);
  const { storeItemData} = useSelector((state) => state.dropdown);
  const [itemCode ,setItemCode] = useState(prodd?.srItemcode)

 
  const handleChange  = (item)=>{
    setItemCode(item)
  }
   
  const handleValuesChange = (changedValues, allValues) => {
    const { srQuantity = 0, srUnitCost = 0 } = allValues;
    const totalCost = srQuantity * srUnitCost;

    form.setFieldsValue({
      srTotalCost: totalCost,
    });
  };

  const onFinish = async (data) => {
    data.srId = prodd ? prodd?.srId : null;
    data.srStatus = "OPEN"
    data.srItemcode = itemCode
    const res = await dispatch(
      save({
        ...data,
        url: "asset/saveStoreRequest.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => { 
    if (prodd) { 
      form.setFieldsValue(prodd); 
    }  else {
      form.resetFields();  
    }
  }, [prodd]); 


  useEffect(()=>{
    setItemCode(prodd?.srItemcode ?? null)
  },[prodd?.srItemcode ?? null])
  
 
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd ? `Edit store request ${prodd?.srNo}` : "Add store request details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form} 
          onValuesChange={handleValuesChange}
        >
             <Form.Item
            name="srItemId"
            className=""
            label={<span>Store Item</span>}
            rules={[
              {
                required: true,
                message: "Please select store item",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                storeItemData?.length > 0 &&
                storeItemData?.map((item) => ({
                  value: item?.stId,
                  label: item?.stName,
                }))
              }
              onChange={(value)=>{
                const item  =  storeItemData && storeItemData?.find((item)=>item?.stId === value)
                handleChange(item?.stItemcode)
              }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
            />
          </Form.Item>

          <Form.Item
            className="table-form-item"
            name="srQuantity"
            label="Quantity"
            rules={[
              {
                required: true,
                message: "Please add quantity",
              },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>
          <Form.Item
            className="table-form-item"
            name="srUnitCost"
            label="Unit cost"
            rules={[
              {
                required: true,
                message: "Please add unit cost",
              },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>
          <Form.Item
            className="table-form-item"
            name="srTotalCost"
            label="Total cost"
            rules={[
              {
                required: true,
                message: "Please add total cost",
              },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>
      
          <Form.Item
            name="srDescription"
            label="Description"
            rules={[
              {
                required: true,
                message: "Enter description",
              },
            ]}
          >
            <TextArea  rows={6} className="input" />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddStoreRequestModal;
